import { useCallback } from 'react';

import { buildHashParam } from '../../utils/buildHash';
import {
  fetchPromoPointsAction,
  fetchPromotionAction,
  fetchPromotionTranslationAction,
} from '../apiActions/fetchPromotionAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';
import { useSettingsSlice } from '../slices/settings/selectors';

export const usePromotionFetcher = () => {
  const dispatch = useCoreDispatch();
  const env = useConfigSlice.env();
  const lang = useSettingsSlice.currentLanguage();
  const gsAddress = useConfigSlice.gsAddress();
  const jwtToken = useConfigSlice.jwtToken();
  const userId = useConfigSlice.userId();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const operatorGameId = useConfigSlice.tableConfig()?.operatorGameId;

  return useCallback(
    (force: boolean = false) => {
      if (jwtToken && gsAddress && userId && JSESSIONID && operatorGameId && lang && env) {
        return dispatch(
          fetchPromotionAction({
            envGs: gsAddress,
            envPromo: env.promoService,
            lang,
            jwtToken,
            userId,
            JSESSIONID,
            operatorGameId,
            force,
          })
        );
      }
    },
    [jwtToken, gsAddress, userId, JSESSIONID, operatorGameId, lang, env, dispatch]
  );
};

const BasePath = location.pathname.substring(0, location.pathname.lastIndexOf('/'));
const PromotionBasePath = BasePath + `/assets/translations/promo/`;

export const usePromotionTranslationFetcher = () => {
  const dispatch = useCoreDispatch();
  const currentLanguage = useSettingsSlice.currentLanguage();

  return useCallback(() => {
    if (currentLanguage) {
      return dispatch(
        fetchPromotionTranslationAction({
          url: `${PromotionBasePath}${currentLanguage}.json`,
          buildHashParam,
        })
      );
    }
  }, [currentLanguage, dispatch]);
};

export const usePromoPointsFetcher = (): (() => void) => {
  const dispatch = useCoreDispatch();
  const env = useConfigSlice.env();
  const jwtToken = useConfigSlice.jwtToken();

  return useCallback(() => {
    if (env && jwtToken) {
      dispatch(
        fetchPromoPointsAction({
          envPromo: env.promoService,
          jwtToken: jwtToken,
        })
      );
    }
  }, [env, jwtToken, dispatch]);
};
